import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        fields: '=',
        showFilter: '='
    },
    template: `
        <div class="table-filters">
                <form ng-submit="vm.applyFilter()" class="form form-filter"  ng-if="vm.showFilter">
                    <div class="fields">
                        <div class="row row-md">
                            <label class="label">{{ 'filter.Course' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.filter.keyword" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="row row-separated">
                            <label class="label">{{ 'filter.Field name' | translate }}</label>
                            <div class="items">
                            <select class="form-control" ng-model="vm.filter.fieldId" ng-options="item.id as item.activeI18n.value for item in vm.fields">
                                <option value=""></option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                        <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                    </ul>
                </form>
        </div>
    `
})
export default class {
    constructor (lodash, ClassifierResource, CLASSIFIER_ENUM) {
        this.lodash = lodash;
        this.ClassifierResource = ClassifierResource;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
    }

    $onInit () {
        this.showFilter = false;
    }

    applyFilter () {
        this.list.fetch(this.filter);
    }

    resetFilter () {
        this.filter = {};
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/application/filter/index.js